/* eslint-disable promise/param-names */
/* eslint-disable prefer-promise-reject-errors */
import Vue from 'vue';
import Vuex from 'vuex';
import { COURIER_ACTIONS, COURIER_STATE, COURIER_MUTATIONS } from './courier';
import portal from '~/net/portal';
import createPersistedState from 'vuex-persistedstate';
import devSearch from './modules/cz';
Vue.use(Vuex);

const store = () =>
  new Vuex.Store({
    state: {
      breadcrumbs: [],
      user: null,
      identities: [],
      backTop: 0,
      screen: {
        width: 0,
        height: 0,
      },
      realNameVisible: false,
      identityVisible: false,
      pwdVisible: false,
      analysis: {},
      ...COURIER_STATE,
    },
    modules: {
      devSearch,
    },
    mutations: {
      SET_BREADCRUMBS(state, breadcrumbs) {
        state.breadcrumbs = breadcrumbs;
      },
      SET_ANALYSIS(state, analysis) {
        state.analysis = analysis;
      },
      SET_USER(state, user) {
        state.user = user;
      },
      SET_IDENTITY(state, identities) {
        state.identities = identities;
      },
      SET_BACKTOP(state) {
        state.backTop += 1;
      },
      SET_SCREEN(state, screen) {
        state.screen = screen;
      },
      SET_REALNAME(state, realNameVisible) {
        state.realNameVisible = realNameVisible;
      },
      SET_IDENTITYVISIBLE(state, identityVisible) {
        state.identityVisible = identityVisible;
      },
      SET_PWDVISIBLE(state, pwdVisible) {
        state.pwdVisible = pwdVisible;
      },
      ...COURIER_MUTATIONS,
    },
    actions: {
      nuxtServerInit({ commit }) {
        console.log('start...');
      },
      LoginIn({ commit }, userinfo) {
        return new Promise((reslove, reject) => {
          portal
            .login({
              body: userinfo,
              client: true,
            })
            .then((res) => {
              if (res.code == '0000') {
                commit('SET_USER', res.data);
                return portal.identities().then((res1) => {
                  commit('SET_IDENTITY', res1.data || []);
                  reslove(res);
                });
              } else {
                reject(res);
              }
            })
            .catch((err) => {
              reject(err);
            });
        });
      },
      otherLogin({ commit }, userinfo) {
        return new Promise((reslove, reject) => {
          portal
            .coordinationCentreTradeUserLogin({
              body: userinfo,
              client: true,
            })
            .then((res) => {
              if (res.code == '0000') {
                reslove(res);
              } else {
                reject(res);
              }
            });
        });
      },
      LoginThird({ commit }, data) {
        return new Promise((reslove, reject) => {
          commit('SET_USER', data);
          return portal.identities().then((res1) => {
            commit('SET_IDENTITY', res1.data || []);
            reslove(res1);
          });
        });
      },
      LoginInWithCode({ commit }, userinfo) {
        return new Promise((reslove, reject) => {
          portal
            .messageLogin({
              body: userinfo,
              client: true,
            })
            .then((res) => {
              if (res.code == '0000') {
                commit('SET_USER', res.data);
                return portal.identities().then((res1) => {
                  commit('SET_IDENTITY', res1.data || []);
                  reslove(res);
                });
              } else {
                reject(res);
              }
            });
        });
      },
      LogOut({ commit }) {
        portal.signout().then((res) => {
          commit('SET_USER', null);
          commit('SET_IDENTITY', []);
        });
      },
      ResizeScreen({ commit }, screen) {
        commit('SET_SCREEN', screen);
      },
      CheckRealName({ commit }) {
        return new Promise((reslove, reject) => {
          if (this.state.user == null) {
            reject(null);
          } else if (this.state.user.userStatus == 2 || this.state.user.userStatus == 5) {
            reslove(true);
          } else {
            reject(false);
          }
        });
      },
      ...COURIER_ACTIONS,
    },
    // 添加插件配置
    plugins: process.client
      ? [
          // 确保只在客户端执行
          createPersistedState({
            key: 'ui-portal-state', // 存储的键名
            //'user', 'devSearch'
            // paths: ['breadcrumbs', 'user', 'devSearch.devSearchItem'], // 需要持久化的状态路径
            storage: window.sessionStorage, // 使用 sessionStorage 存储
          }),
        ]
      : [],
  });

export default store;
